import config from '~/config'
import { getClubConfig } from '~/config/clubConfig'
import { gt as GT } from '~/locale'

export const CHECKOUT_FOOTER_ITEMS = (gt: typeof GT) => [
  {
    image: '/assets/checkout-page/shield.svg',
    content: gt.tp('CheckoutPage', '100% secure payments'),
  },
  {
    image: '/assets/checkout-page/coin.svg',
    content: gt.tp('CheckoutPage', 'Refunds up to 24 hours before the start of the booking'),
  },
  {
    image: '/assets/checkout-page/thumbsup.svg',
    content: getClubConfig().useRWInsteadOfRC
      ? gt.tp('CheckoutPage', '97% of guests recommend RestaurantWeek to friends')
      : gt.tp('CheckoutPage', '97% of guests recommend Restaurant Club to friends'),
  },
  {
    image: '/assets/checkout-page/klarna.svg',
    content: gt.tp('CheckoutPage', 'Pay within 30 days. Without charging.'),
    hidden: !config().enableKlarna,
  },
]
